import * as Debug from 'debug';
import {AfterViewInit, Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Note} from '../shared/types/note';
import {ActivatedRoute, Router} from '@angular/router';
import {NoteService, PurchaseMicroService} from '../shared/services/note_service';
import {StreamService} from '../shared/services/stream_service';

import {UserService} from '../shared/services/user_service';

import {User} from '../shared/types/user';
import {isPlatformBrowser} from '@angular/common';

const debug = Debug('notd:note-details');

@Component({
  selector: 'app-note-details',
  templateUrl: './note-details.component.html',
  styleUrls: ['./note-details.component.scss']
})
export class NoteDetailsComponent implements AfterViewInit, OnInit, OnDestroy {
  public note: Note;
  public newComment: string;
  public purchaseService: PurchaseMicroService;

  userRate: any = 0;
  rateStarsClicked = false;
  extendCommentSpace = false;
  isLoggedIn = false;
  isNoteOwner = false;
  isBookmarked = false;
  showPreviousThreadLink = false;
  showNextThreadLink = false;

  private getSubscriptionStatusUpdateSub;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private noteService: NoteService,
    private streamService: StreamService,
    private userService: UserService,
    private titleService: Title,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) protected platformId: Object) {
  }

  ngOnInit() {
    debug('ngOnInit starting');
    this.isLoggedIn = this.userService.isLoggedIn();

    this.route.params.subscribe(() => {
      this.note = this.route.snapshot.data.note;
      this.note.status = this.route.snapshot.data.noteStatus;
      this.titleService.setTitle(this.note.name + ' - notd.io');

      if (isPlatformBrowser(this.platformId) && this.note) {
        this.checkForParentChildNotes();
      }
    });

    if (this.isLoggedIn) {
      this.userService.getProfile()
        .then((user: User) => {
          this.isNoteOwner = (user.id.toString() === this.note.userId.toString()) ? true : false;
        });
    }

    this.getSubscriptionStatusUpdateSub = this.streamService.getSubscriptionStatusUpdate().subscribe(res => {
      if (res.active === 1) {
        Object.assign(this.note, {
          status: res.active
        });

        debug('ngOnInit call loadNotePremiumContent');
        this.noteService.loadNotePremiumContent(this.note)
          .then((note) => {
            this.note = note;
          })
          .catch((resp) => {
            console.log('NoteDetailsComponent: error retrieving note premium content', resp);
          });
      }
    });
  }

  ngAfterViewInit() {
    // this handler should be called last
    debug('ngAfterViewInit');
  }
  checkForParentChildNotes() {
    if (this.note.parentPostId.length > 0) {
      this.showPreviousThreadLink = true;
    }

    if (this.note.childPosts.length > 0) {
      this.showNextThreadLink = true;
    }
  }

  showNotes(type: string) {
    if (type === 'parent') {
      this.router.navigate(['/thread', this.note.parentPostId]);
    } else {
      this.router.navigate(['/thread', this.note.childPosts[0]]);
    }
  }

  ngOnDestroy() {
    if (this.getSubscriptionStatusUpdateSub) {
      this.getSubscriptionStatusUpdateSub.unsubscribe();
    }
  }

}
